import React from 'react';

export type SectionContextType = string;

export const defaultSectionContext = '';

export const SectionContext = React.createContext<SectionContextType>(
  defaultSectionContext,
);
